// CONFIGURE
import configGeneral from './configure/general'
import Channels from '@/plugins/i18n/locales/en/configure/Channels'
import AppConfig from '@/plugins/i18n/locales/en/configure/AppConfig'

// CONNECT
import connectGeneral from './connect/general'

// CONVERSATIONS
import conversationsGeneral from './conversations/general'
import conversationsDetails from './conversations/details'
import newConversation from '@/plugins/i18n/locales/en/conversations/newConversation'
import chat from '@/plugins/i18n/locales/en/conversations/chat'
import Filters from '@/plugins/i18n/locales/en/conversations/Filters'
import OpportunitiesInChat from '@/plugins/i18n/locales/en/conversations/OpportunitiesInChat'
import smartChat from './conversations/smartChat'

// DASHBOARD
import dashboardGeneral from './dashboard/general'
import dashboardSignIn from './dashboard/signin'
import superAdmin from './dashboard/superAdmin'

// WIZARD
import wizard from './wizard/wizard'

// LAYOUT
import layout from './layout/general'

// Billing
import billingDialogs from './Billing/dialogs'
import billingPlans from './Billing/Plans'
import BillingDashboard from '@/plugins/i18n/locales/en/Billing/BillingDashboard'
import chatConfig from './configure/chatConfig'

// Administrators
import administrator from './administrator/administrator'

// Onboarding
import onboarding from './Onboarding/index'

// Extensions
import extensions from './Extensions/general'

// campaign
import campaign from './campaign/general'

// AUTOMATE - triggers
import triggersGeneral from './automate/general'

// Microsites
import micrositesGeneral from './microsites/general'

// EVENTS
import events from './events/general'

export default {
  ...configGeneral,
  ...connectGeneral,
  ...conversationsGeneral,
  ...AppConfig,
  ...conversationsDetails,
  ...newConversation,
  ...dashboardGeneral,
  ...dashboardSignIn,
  ...wizard,
  ...billingDialogs,
  ...billingPlans,
  ...superAdmin,
  ...Channels,
  ...chatConfig,
  ...BillingDashboard,
  ...superAdmin,
  ...chat,
  ...Filters,
  ...layout,
  ...administrator,
  ...onboarding,
  ...extensions,
  ...campaign,
  ...triggersGeneral,
  ...OpportunitiesInChat,
  ...micrositesGeneral,
  ...events,
  ...smartChat
}
